import { Button, Card, Checkbox, Collapse, DatePicker, Form, Input, Select, Upload } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FiUpload } from 'react-icons/fi';
export default function ImportCollection() {
    const { t } = useTranslation();
    const postUser = useCallback(async (values) => {
        try {
        } catch (err) { }
    }, [])
    const handleAction1 = useCallback(({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 1000)
    })

    const handleAction2 = useCallback(({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 1000)
    })

    const handleAction3 = useCallback(({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 1000)
    })

    const handleAction4 = useCallback(({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 1000)
    })

    return (
        <Form layout="vertical" onFinish={postUser}>
            <Card size="small" className="mb-2 breadcrumb-card">
                <div className='row' style={{ marginTop: 35, marginBottom: 20 }}>
                    <div className='col-6'>
                        <Checkbox style={{ marginTop: 10 }}>Existing Template</Checkbox>
                    </div>

                    <div className='col-6'>
                        <Input size="large" placeholder='Search' style={{ width: '100%', marginBottom: 10 }} />
                        <Checkbox>New Export Collection</Checkbox>
                    </div>
                </div>
                <div className="trade-finance-collapse">
                    <Collapse
                        defaultActiveKey={['1']}
                        className='mb-3'
                        items={[
                            {
                                key: '1',
                                label: 'Parties',
                                children: <div className='row'>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <Form.Item label='Customer ID' name='E1'>
                                            <Select size="large" placeholder='Choose Customer ID'>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>

                                        <Form.Item label='Branch' name='E2'>
                                            <Select size="large" placeholder='Choose Branch'>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>

                                        <Form.Item label='Date of Application' name='E3'>
                                            <DatePicker size="large" style={{ width: '100%' }} />
                                        </Form.Item>

                                        <Form.Item label='Customer Reference Number' name='E4'>
                                            <Input size="large" />
                                        </Form.Item>

                                        <Form.Item label='Product' name='E5'>
                                            <Input size="large" />
                                        </Form.Item>
                                    </div>
                                    <div className='col-6'>
                                        <Form.Item label='Drawee ID' name='E6'>
                                            <Select size="large" placeholder='Choose Drawee ID '>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>

                                        <Form.Item label='Name' name='E7'>
                                            <Input size="large" />
                                        </Form.Item>

                                        <Form.Item label='Address' name='E8'>
                                            <Input size="large" placeholder='Address Line 1' />
                                        </Form.Item>

                                        <Form.Item label='' name='E9'>
                                            <Input size="large" placeholder='Address Line 2' />
                                        </Form.Item>

                                        <Form.Item label='' name='E10'>
                                            <Input size="large" placeholder='Address Line 3' />
                                        </Form.Item>

                                        <Form.Item label='' name='EE1'>
                                            <Select size="large" placeholder='Choose Country'>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </div>
                                    <div className='col-6'>
                                        <h5>Drawer</h5>

                                        <Form.Item label='Name' name='EE2'>
                                            <Input size="large" />
                                        </Form.Item>

                                        <Form.Item label='Address' name='EE3'>
                                            <Input size="large" placeholder='Address Line1' />
                                        </Form.Item>
                                        <Form.Item label='' name='EE4'>
                                            <Input size="large" placeholder='Address Line2' />
                                        </Form.Item>
                                        <Form.Item label='' name='EE4'>
                                            <Input size="large" placeholder='Address Line3' />
                                        </Form.Item>

                                        <Form.Item label='' name='EE5'>
                                            <Select size="large" placeholder='Choose Country'>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </div>

                                    <div className='col-6'>
                                        <h5>Drawee Bank</h5>

                                        <Form.Item label='Swift Code' name='EE6'>
                                            <Input size="large" />
                                        </Form.Item>

                                        <Form.Item label='Name' name='EE7'>
                                            <Input size="large" />
                                        </Form.Item>

                                        <Form.Item label='Address' name='EE8'>
                                            <Input size="large" placeholder='Address Line1' />
                                        </Form.Item>
                                        <Form.Item label='' name='EE9'>
                                            <Input size="large" placeholder='Address Line2' />
                                        </Form.Item>
                                        <Form.Item label='' name='EE10'>
                                            <Input size="large" placeholder='Address Line3' />
                                        </Form.Item>

                                        <Form.Item label='' name='ER1'>
                                            <Select size="large" placeholder='Choose Country'>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>,
                            },
                        ]}
                    />
                    <Collapse
                        className='mb-3'
                        items={[

                            {
                                key: '2',
                                label: 'Bill Details',
                                children: <div className='row'>
                                    <div className='col-4'>
                                        <Form.Item label='Bill Type' name='ER2'>
                                            <Select size="large" placeholder='Choose Bill Type'>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </div>
                                    <div className='col-8'>
                                        <Form.Item label='Bill Number' name='ER3'>
                                            <Input size="large" />
                                        </Form.Item>
                                    </div>

                                    <div className='col-4'>
                                        <Form.Item label='Tenor' name='ER4'>
                                            <Input size="large" />
                                        </Form.Item>
                                    </div>

                                    <div className='col-4'>
                                        <Form.Item label='Tenor Type' name='ER5'>
                                            <Select size="large" placeholder=' Tenor Type'>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </div>

                                    <div className='col-4'>
                                        <Form.Item label='Tenor' name='ER6'>
                                            <DatePicker size="large" style={{ width: '100%' }} />
                                        </Form.Item>
                                    </div>
                                    <div className='col-6'>
                                        <Form.Item label='Maturity Date' name='ER7'>
                                            <DatePicker size="large" style={{ width: '100%' }} />
                                        </Form.Item>
                                    </div>

                                    <div className='col-6'>
                                        <Form.Item label='Name of Vessel' name='ER8'>
                                            <Input size="large" />
                                        </Form.Item>
                                    </div>

                                    <div className='col-6'>
                                        <Form.Item label='Port of Landing' name='ER9'>
                                            <Input size="large" />
                                        </Form.Item>
                                    </div>

                                    <div className='col-6'>
                                        <Form.Item label='Port of Discharge' name='ER10'>
                                            <Input size="large" />
                                        </Form.Item>
                                    </div>

                                    <div className='col-6'>
                                        <Form.Item label='Goods Type' name='ER11'>
                                            <Select size="large" placeholder='Choose Goods Type'>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </div>

                                    <div className='col-6'>
                                        <Form.Item label='Template Access' name='ER12'>
                                            <Select size="large" placeholder='Choose Template Access'>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </div>

                                    <div className='col-12'>
                                        <Form.Item label='Description of Goods' name='ER13'>
                                            <Input.TextArea rows={5} />
                                        </Form.Item>
                                    </div>
                                </div>,
                            },
                        ]}
                    />
                    <Collapse
                        className='mb-3'
                        items={[
                            {
                                key: '3',
                                label: 'Documents',
                                children: <div className='row'>
                                    <div className='col-12' style={{ marginBottom: 10 }}>
                                        <Card>
                                            <div className='row'>
                                                <div className='col-1'>
                                                    <Checkbox style={{ marginTop: 30 }}></Checkbox>
                                                </div>
                                                <div className='col-4'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Documents' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-4'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='First Mail Original' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-3'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Copies' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-1'>

                                                </div>
                                                <div className='col-4' >
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Second Mail Original' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-3'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Copies' />
                                                    </Form.Item>
                                                </div>

                                                <div className='col-2'>
                                                    <Upload customRequest={handleAction1}>
                                                        <FiUpload style={{ marginTop: 8, fontSize: 20 }} />
                                                    </Upload>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>

                                    <div className='col-12' style={{ marginBottom: 10 }}>
                                        <Card>
                                            <div className='row'>
                                                <div className='col-1'>
                                                    <Checkbox style={{ marginTop: 30 }}></Checkbox>
                                                </div>
                                                <div className='col-4'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Documents' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-4'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='First Mail Original' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-3'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Copies' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-1'>

                                                </div>
                                                <div className='col-4' >
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Second Mail Original' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-3'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Copies' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-2'>
                                                    <Upload customRequest={handleAction2}>
                                                        <FiUpload style={{ marginTop: 8, fontSize: 20 }} />
                                                    </Upload>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>

                                    <div className='col-12' style={{ marginBottom: 10 }}>
                                        <Card>
                                            <div className='row'>
                                                <div className='col-1'>
                                                    <Checkbox style={{ marginTop: 30 }}></Checkbox>
                                                </div>
                                                <div className='col-4'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Documents' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-4'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='First Mail Original' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-3'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Copies' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-1'>

                                                </div>
                                                <div className='col-4' >
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Second Mail Original' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-3'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Copies' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-2'>
                                                    <Upload customRequest={handleAction3}>
                                                        <FiUpload style={{ marginTop: 8, fontSize: 20 }} />
                                                    </Upload>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>

                                    <div className='col-12' style={{ marginBottom: 10 }}>
                                        <Card>
                                            <div className='row'>
                                                <div className='col-1'>
                                                    <Checkbox style={{ marginTop: 30 }}></Checkbox>
                                                </div>
                                                <div className='col-4'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Documents' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-4'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='First Mail Original' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-3'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Copies' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-1'>

                                                </div>
                                                <div className='col-4' >
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Second Mail Original' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-3'>
                                                    <Form.Item label='' name='ER14'>
                                                        <Input size="large" placeholder='Copies' />
                                                    </Form.Item>
                                                </div>
                                                <div className='col-2'>
                                                    <Upload customRequest={handleAction4}>
                                                        <FiUpload style={{ marginTop: 8, fontSize: 20 }} />
                                                    </Upload>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>

                                    <div className='col-12'>
                                        <Form.Item label='Template Access Type' name='ER13'>
                                            <Select size="large" placeholder='Choose Template Access'>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>,
                            },
                        ]}
                    />
                    <Collapse
                        className='mb-3'
                        items={[

                            {
                                key: '4',
                                label: 'Settlement Details',
                                children: <div className='row'>
                                    <div className='col-12' style={{ margin: '30px 0' }}>
                                        <Checkbox>Forward Exchange Contract No's</Checkbox>
                                    </div>

                                    <div className='col-4'>
                                        <Form.Item label='Deal Number' name='ER14'>
                                            <Input size="large" />
                                        </Form.Item>
                                    </div>

                                    <div className='col-4'>
                                        <Form.Item label='Currency' name='ER15'>
                                            <Select size="large" placeholder='Choose Currency'>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </div>

                                    <div className='col-4'>
                                        <Form.Item label='Amount' name='ER16'>
                                            <Input size="large" />
                                        </Form.Item>
                                    </div>
                                </div>,
                            },
                        ]}
                    />
                    <Collapse
                        className='mb-3'
                        items={[
                            {
                                key: '5',
                                label: 'Instructions',
                                children: <> <div
                                    className='row'
                                    style={{
                                        margin: '20px 0',
                                    }}>
                                    <div className='col-8'>
                                        <Checkbox>Our bank charges are for the account of</Checkbox>
                                    </div>
                                    <div className='col-4'>
                                        <Select size="large" placeholder='Select' style={{ width: '100%' }}>
                                            <Select.Option value='O'>Organization</Select.Option>
                                            <Select.Option value='I'>Individual</Select.Option>
                                        </Select>
                                    </div>
                                </div>

                                    <div
                                        className='row'
                                        style={{
                                            margin: '20px 0',
                                        }}>
                                        <div className='col-8'>
                                            <Checkbox>If charges/interest are refused then Collecting bank can either</Checkbox>
                                        </div>
                                        <div className='col-4'>
                                            <Select size="large" placeholder='Select' style={{ width: '100%' }}>
                                                <Select.Option value='O'>Organization</Select.Option>
                                                <Select.Option value='I'>Individual</Select.Option>
                                            </Select>
                                        </div>
                                    </div>

                                    <div
                                        className='row'
                                        style={{
                                            margin: '20px 0',
                                        }}>
                                        <div className='col-6'>
                                            <Checkbox>Collect Interest at</Checkbox>
                                        </div>

                                        <div className='col-2'>
                                            <Input size="large" placeholder='%' />
                                        </div>

                                        <div className='col-4'>
                                            <DatePicker size="large" placeholder='Date of  Payment' />
                                        </div>
                                    </div>

                                    <div
                                        className='row'
                                        style={{
                                            margin: '20px 0',
                                        }}>
                                        <div className='col-4'>
                                            <Checkbox>Collect Interest</Checkbox>
                                        </div>
                                        <div className='col-8'>
                                            <Input size="large" placeholder='from date of first presentation until date of acceptance and from due date until date of payment' />
                                        </div>
                                    </div>

                                    <div
                                        className='row'
                                        style={{
                                            margin: '20px 0',
                                        }}>
                                        <div className='col-6'>
                                            <Checkbox>Protest for non payment</Checkbox>
                                        </div>
                                        <div className='col-6'>
                                            <Checkbox>Protest for non acceptance</Checkbox>
                                        </div>
                                    </div>

                                    <div
                                        className='row'
                                        style={{
                                            margin: '20px 0',
                                        }}>
                                        <div className='col-12'>
                                            <Checkbox>
                                                This collection and any further relevant advice are subject to Uniform Rules for
                                                Collection (1995 Revision)ICC Publication Number 522
                                            </Checkbox>
                                        </div>
                                    </div></>,
                            },
                        ]}
                    />



                </div>
                <div className="d-flex justify-content-end  mt-3">
                    <Button type="primary" size="large" htmlType="submit">
                        {t("buttons.submit", {
                            defaultValue: "Submit",
                        })}
                    </Button>
                </div>
            </Card>
        </Form>

    )
}